<template>
  <div>
    <v-form
      ref="form"
      class="mx-2"
      lazy-validation
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="py-0"
        >
          <v-text-field
            ref="member"
            v-model="localData.memberModel.fullName"
            label="درخواست کننده"
            :error-messages="errorMessages"
            readonly
            disabled
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="py-0"
        >
          <v-text-field
            ref="requestDate"
            v-model="localData.requestDate_Persian.date"
            label="تاریخ درخواست"
            readonly
            disabled
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="py-0"
        >
          <v-text-field
            ref="loan"
            v-model="localData.loanModel.title"
            label="نوع وام"
            :error-messages="errorMessages"
            :rules="[() => !!localData.loanModel || 'وام را انتخاب کنید']"
            readonly
            disabled
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="py-0"
        >
          <v-text-money
            ref="amount"
            v-model="localData.amount"
            :label="'مبلغ'"
            :error-messages="errorMessages"
            :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']"
            required
            readonly
            disabled
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="py-0"
        >
          <v-textarea
            v-model="localData.comment"
            outlined
            :error-messages="errorMessages"
            label="توضیحات درخواست کننده"
            hint="حداکثر 1000 کاراکتر"
            readonly
            disabled
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="py-0"
        >
          <div class="black--text">
            وضعیت درخواست:
          </div>
          <v-select
            v-model="localData.status"
            clearable
            required
            single-line
            return-object
            :items="statuses"
            label="انتخاب کنید*"
            item-text="title"
            item-value="id"
            :error-messages="errorMessages"
            :rules="[() => !!localData.status && localData.status.id > 0 || 'وضعیت را انتخاب کنید']"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="py-0"
        >
          <div class="black--text">
            اولویت:
          </div>
          <div style="display:flex">
            <div class="pl-2">
              <v-select
                v-model="localData.month"
                clearable
                required
                single-line
                return-object
                :items="months"
                label="ماه"
                item-text="title"
                item-value="id"
                :error-messages="errorMessages"
                :rules="[() => localData.status.id <= 3 || (localData.month && localData.month.id > 0) || 'ماه را انتخاب کنید']"
              />
            </div>
            <div>
              <v-text-field
                ref="year"
                v-model="localData.year"
                label="سال"
                :error-messages="errorMessages"
                :rules="[() => localData.status.id <= 3 || !!localData.year || 'سال را وارد کنید']"
              />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
          <v-textarea
            v-model="localData.adminDescription"
            outlined
            :error-messages="errorMessages"
            label="نظر هیئت مدیره"
            hint="حداکثر 1000 کاراکتر"
          />
        </v-col>
      </v-row>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn
        @click="$emit('callbck',false)"
      >
        بستن
      </v-btn>
      <v-btn
        color="blue"
        dark
        @click="submit()"
      >
        ذخیره
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import { emptyId } from '@/util/emptyId'

  export default {
    name: 'ModifyRequestView',
    props: {
      data: { type: Object },
    },
    data () {
      return {
        errorMessages: '',
        localData: { loanModel: {}, memberModel: {}, requestDate_Persian: {} },
        loans: [],
        statuses: [
          { id: 1, title: 'جدید' },
          { id: 2, title: 'در حال بررسی' },
          { id: 3, title: 'عدم تایید' },
          { id: 4, title: 'اولویت بندی شده' },
          { id: 5, title: 'پرداخت شده' },
        ],
        months: [
          { id: 1, title: 'فروردین' },
          { id: 2, title: 'اردیبهشت' },
          { id: 3, title: 'خرداد' },
          { id: 4, title: 'تیر' },
          { id: 5, title: 'مرداد' },
          { id: 6, title: 'شهریور' },
          { id: 7, title: 'مهر' },
          { id: 8, title: 'مهر' },
          { id: 9, title: 'مهر' },
          { id: 10, title: 'مهر' },
          { id: 11, title: 'مهر' },
          { id: 12, title: 'اسفند' },
        ],
      }
    },
    mounted () {
      // this.prepareData()
    },
    methods: {
      submit () {
        if (!this.$refs.form.validate()) { return }

        var data = {}
        Object.assign(data, this.localData)
        data.status = this.localData.status.id
        data.month = this.localData.month.id
        api.post('admin/userLoanRequest/' + (this.localData.id === emptyId ? 'create' : 'edit'), data)
          .then(
            response => {
              toast.success('اطلاعات با موفقیت ذخیره شد.')
              this.$emit('callbck', true)
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      prepareData () {
        if (!this.data) {
          this.data = { id: emptyId }
        }
        if (!this.data.id) {
          this.data.id = emptyId
        }
        api.get('admin/userLoanRequest/get/' + this.data.id, null)
          .then(
            response => {
              this.localData = response
              if (this.data.id === emptyId) Object.assign(this.localData, this.data)
              this.localData.status = { id: this.localData.status }
              this.localData.month = { id: this.localData.month }
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
    },
  }
</script>
<style>
</style>
